import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";

const TechStackCard = (props) => {
  const myRef = useRef(null);
  const [imageUrlDefault, setImageUrlDefault] = useState(props.imageUrlDefault);
  const [imageUrlOnHover, setImageUrlOnHover] = useState(props.imageUrlOnHover);
  const [iconName, setIconName] = useState(props.iconName);
  const [iconId, setIconId] = useState(props.id);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    setImageUrlDefault(props.imageUrlDefault);
    setImageUrlOnHover(props.imageUrlOnHover);
    setIconName(props.iconName);
    setIconId(props.id);
    revertColor();
  }, []);

  const changeColor = () => {
    setHover(true);
    myRef.current.style.display = "block";
  };

  const revertColor = () => {
    setHover(false);
    myRef.current.style.display = "none";
  };

  return (
    <div
      style={{
        margin: "50px",
        height: "100px",
        width: "100px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CardMedia
        id={iconId}
        onMouseEnter={changeColor}
        onMouseLeave={revertColor}
        component="img"
        image={hover ? imageUrlOnHover : imageUrlDefault}
        alt="tech stack icon"
      />
      <CardContent>
        <Typography
          ref={myRef}
          style={{ textAlign: "center" }}
          gutterBottom
          variant="h5"
          component="div"
        >
          {iconName}
        </Typography>
      </CardContent>
    </div>
  );
};

export default TechStackCard;
